import React from 'react';
import Tooltip from '../Tooltip';
import styled from 'styled-components';

import { getTextBackgroundStyle } from 'components/Studio/textBackground';

import Row from '../Common/Row';
import ReactQuill from 'react-quill-new';
// Reads (and keeps) the size a heading gives part of a line in Studio, and
// its text colours
import 'components/Studio/textSizeFormat';
import { TEXT_COLOR_CSS } from 'components/Studio/textColorFormat';
import ShowOnMouseOverUnlessTour from '../ShowOnMouseOverUnlessTour';
import Button from 'kingpin/atoms/Button';
import { Z_INDEX } from '../../constants';

const Wrapper = styled.div<{
  isCenterAlign: boolean;
  isBottomAlign: boolean;
}>`
  padding: 0px !important;
  display: flex;
  flex-direction: column;
  flex: 1;

  h1 {
    margin: 0px !important;
  }

  ${TEXT_COLOR_CSS}

  .showOnMouseOver {
    visibility: hidden;
  }

  &:hover {
    > .showOnMouseOver {
      visibility: visible;
    }
  }

  .ql-container.ql-snow {
    border: none;
  }

  .ql-container {
    font-size: unset;
  }

  .ql-editor {
    padding: 0.6em 0.8em 0em 0.8em !important;
    color: var(--color-text-primary);
  }

  html[data-theme='dark'] & .ql-editor {
    [style*='color: rgb(0, 0, 0)'],
    [style*='color: black'] {
      color: var(--color-text-primary) !important;
    }
  }

  ${(props) =>
    props.isCenterAlign &&
    `
    .ql-editor {
      display: flex !important;
      align-items: center !important;
    }
  `}

  /* At the foot of the card, as Studio can set it, its paragraphs kept one
     under another */
  ${(props) =>
    !props.isCenterAlign &&
    props.isBottomAlign &&
    `
    .ql-editor {
      display: flex !important;
      flex-direction: column !important;
      justify-content: flex-end !important;
    }
  `}
`;

const TextGadget = ({
  text,
  isCenterAlign,
  isBottomAlign = false,
  onEdit,
  isEditingCanvas,
  background,
  body,
}: {
  text: string;
  isCenterAlign: boolean;
  // Set in Studio (see Studio.TextStudioSettings)
  isBottomAlign?: boolean;
  // Absent when it can't be edited here (Studio's Markdown)
  onEdit?: () => void;
  isEditingCanvas: boolean;
  // Studio's tile colours
  background?: Studio.TextBackground;
  // Shown instead of the text as typed, e.g. with Studio's placeholders
  // filled in
  body?: JSX.Element;
}) => (
  <Wrapper
    isCenterAlign={isCenterAlign}
    isBottomAlign={isBottomAlign}
    style={getTextBackgroundStyle(background)}
    data-testid="text-gadget"
    data-background={background}
  >
    {!isEditingCanvas && onEdit && (
      <ShowOnMouseOverUnlessTour>
        <Row
          style={{
            zIndex: Z_INDEX.TEXT_GADGET,
            position: 'absolute',
            right: 13,
            top: 5,
            justifyContent: 'flex-end',
          }}
        >
          <Tooltip content={'Edit'}>
            <div style={{ marginLeft: 8 }}>
              <Button
                onClick={onEdit}
                type="Secondary"
                size="Small"
                icon={'edit-filled'}
              />
            </div>
          </Tooltip>
        </Row>
      </ShowOnMouseOverUnlessTour>
    )}
    {body ?? (
      <ReactQuill
        value={text}
        readOnly
        modules={{ toolbar: false }}
        style={{ width: '100%' }}
      />
    )}
  </Wrapper>
);

export default TextGadget;
